<app-page-spinner-component [state]="spinnerState"></app-page-spinner-component>
<header class="fixed-top">
  <app-header-application></app-header-application>
</header>

<section class="d-flex flex-fill pt-8">
   <app-sidebar-nav class="sidebar flex-shrink-0 d-none d-lg-block"  *ngIf="user && (user.isGapsInCareUser || user.isInsightAnalyticUser || user.allowSearch || user.canAccessOrganizations)"></app-sidebar-nav>

   <div class="d-flex flex-column flex-fill overflow-hidden main-content-wrapper">
    <div class="flex-fill pb-6">
      <app-notifications [target]="'top-app'" [extraCss]="'shadow'"></app-notifications>
      <router-outlet></router-outlet>
    </div>
    
    <app-footer-application></app-footer-application>
    
  </div>

</section>
